import styled from "@emotion/styled";

export const PostTitle = styled("h2")`
    ${({ theme }) => theme.text.h2}
    margin: 0;
    margin-bottom: 24px;
`;
